<!-- Creating fake references to the dynamic component, so that, IVY compiler will not ignore those components while building the app. See https://dev.azure.com/cudirect/POS/_workitems/edit/134084. -->

<div *ngIf="false">
  <!-- field Components  -->
  <cu-toggle></cu-toggle>
  <cu-textarea></cu-textarea>
  <cu-radio></cu-radio>
  <cu-input></cu-input>
  <cu-input-obfuscate></cu-input-obfuscate>
  <cu-input-mask></cu-input-mask>
  <cu-info-row-obfuscate></cu-info-row-obfuscate>
  <cu-info-row></cu-info-row>
  <cu-field-group></cu-field-group>
  <cu-dropdown></cu-dropdown>
  <cu-content></cu-content>
  <cu-checkbox-group></cu-checkbox-group>
  <cu-checkbox></cu-checkbox>
  <cu-button></cu-button>
  <cu-bulleted-list></cu-bulleted-list>
  <cu-selection-grid></cu-selection-grid>
  <cu-alert></cu-alert>

  <ecp-accounts-and-services></ecp-accounts-and-services>
  <ecp-app-prefill></ecp-app-prefill>
  <ecp-asset-allocation></ecp-asset-allocation>
  <ecp-autofill-application></ecp-autofill-application>
  <ecp-autofill-info-driver-license></ecp-autofill-info-driver-license>
  <ecp-disclosure></ecp-disclosure>
  <ecp-dynamic-custom-field></ecp-dynamic-custom-field>
  <ecp-dynamic-eligibility></ecp-dynamic-eligibility>
  <ecp-dynamic-personal-info></ecp-dynamic-personal-info>
  <ecp-identity-verification></ecp-identity-verification>
  <ecp-alloy-verification></ecp-alloy-verification>
  <ecp-joint-credit-select></ecp-joint-credit-select>
  <ecp-loan-type></ecp-loan-type>
  <ecp-field-group-card></ecp-field-group-card>
  <ecp-dynamic-requested-doc></ecp-dynamic-requested-doc>
  <!--  cards -->
  <cu-standard-card></cu-standard-card>
  <ecp-requested-doc-review-card></ecp-requested-doc-review-card>
  <cu-dynamic-document-card-fields></cu-dynamic-document-card-fields>

  <!-- pages -->
  <cu-standard-review-page></cu-standard-review-page>
  <ecp-autofill-preview></ecp-autofill-preview>
  <cu-standard-page></cu-standard-page>
  <ecp-legacy-review-page></ecp-legacy-review-page>
  <ecp-oao-accounts-services-review></ecp-oao-accounts-services-review>
  <ecp-slideout-page></ecp-slideout-page>
  <ecp-oao-eligibility></ecp-oao-eligibility>
  <ecp-ola-eligibility></ecp-ola-eligibility>
  <ecp-ola-interstitial></ecp-ola-interstitial>

  <!-- modals -->
  <ecp-oao-confirm-delete-applicant></ecp-oao-confirm-delete-applicant>
  <ecp-oao-confirm-membership></ecp-oao-confirm-membership>
  <ecp-oao-confirm-delete-beneficiary></ecp-oao-confirm-delete-beneficiary>
  <ecp-oao-confirm-leave></ecp-oao-confirm-leave>
  <ecp-migrated-application></ecp-migrated-application>
  <ecp-ola-confirm-loan-group></ecp-ola-confirm-loan-group>
  <ecp-silent-verification></ecp-silent-verification>
</div>
